import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles({
  chip: {
    width: 132,
    height: 43,
    fontSize: 16,
    textTransform: 'capitalize',
    borderRadius: 10,
  },
  active: {
    backgroundColor: '#1921fa',
  },
  redeemed: {
    backgroundColor: '#09bd3c',
  },
  canceled: {
    backgroundColor: '#e02020',
  },
  expired: {
    backgroundColor: '#ff9f34',
  },
});
